import { render } from "./ServiceGa.vue?vue&type=template&id=ee264394&scoped=true"
import script from "./ServiceGa.vue?vue&type=script&lang=js"
export * from "./ServiceGa.vue?vue&type=script&lang=js"

import "./ServiceGa.vue?vue&type=style&index=0&id=ee264394&scoped=true&lang=css"

import exportComponent from "/home/devnote/Documentos/Features/Home Creditall/site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee264394"]])

export default __exports__